import { PersonBase } from './person-base';

export class PersonTable extends PersonBase {
  class?: string;
  telefon?: string;
  organization?: string;
}
